<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Student Notes</span>
            </div>
            <div style="display: flex; flex: 1; flex-direction: row;">
                <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center">
                    <button mat-stroked-button class="mat-card-button" (click)="viewStudentNotesClick()"><span translate>Go To Notes</span>
                    </button>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
            <div style="display: flex;align-items: center;" *ngIf="studentNotes.length == 0">
                No notes exist for student.
            </div>
            <div *ngIf="studentNotes.length > 0" style="width: 100%; padding-left: 24px;padding-top: 15px;padding-bottom: 15px;">
                <div *ngFor="let cat of categories">
                    <div style="font-weight: 600;font-size: 11pt;padding-bottom: 8px;">{{cat}}</div>
                    <div *ngFor="let note of studentNotes">
                        <div *ngIf="note.Definition == cat">
                            <div style="display: flex;padding-bottom: 5px;">
                                <div style="padding-right: 15px;font-size: 17pt;margin-top: -6px;">&#8226;</div>
                                <div [ngStyle]="{'font-weight': note.DisplayBold ? 'bold' : ''}">{{note.Note}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-card>
